(function () {
    angular
      .module('kareo.ui.shared.directives.state-codes', [])
      .constant('STATE_CODES', Object.freeze([
        { stateCode: 'IN' }, { stateCode: 'KY' }, { stateCode: 'OH' }, { stateCode: 'VA' },
        { stateCode: 'WV' }, { stateCode: 'IL' }, { stateCode: 'UT' }, { stateCode: 'IA' },
        { stateCode: 'LA' }, { stateCode: 'ME' }, { stateCode: 'MS' }, { stateCode: 'ND' },
        { stateCode: 'NE' }, { stateCode: 'RI' }, { stateCode: 'SD' }, { stateCode: 'WY' },
        { stateCode: 'CT' }, { stateCode: 'DE' }, { stateCode: 'MA' }, { stateCode: 'MD' },
        { stateCode: 'NH' }, { stateCode: 'NJ' }, { stateCode: 'NY' }, { stateCode: 'PA' },
        { stateCode: 'VT' }, { stateCode: 'AR' }, { stateCode: 'MO' }, { stateCode: 'TX' },
        { stateCode: 'AZ' }, { stateCode: 'CA' }, { stateCode: 'FL' }, { stateCode: 'GA' },
        { stateCode: 'NM' }, { stateCode: 'NV' }, { stateCode: 'MI' }, { stateCode: 'WI' },
        { stateCode: 'NC' }, { stateCode: 'AK' }, { stateCode: 'CO' }, { stateCode: 'HI' },
        { stateCode: 'ID' }, { stateCode: 'KS' }, { stateCode: 'MN' }, { stateCode: 'MT' },
        { stateCode: 'OR' }, { stateCode: 'WA' }, { stateCode: 'AL' }, { stateCode: 'TN' },
        { stateCode: 'DC' }, { stateCode: 'SC' }, { stateCode: 'OK' }, { stateCode: 'VI' },
        { stateCode: 'GE' }, { stateCode: 'GU' }, { stateCode: 'PR' }
      ]));
  })();
  